export default __webpack_public_path__ + "static/how-it-works-58f48a57a435e468a10bb6cff4c13cb3.webp";